import { render, staticRenderFns } from "./web3.vue?vue&type=template&id=47d69866&scoped=true&"
import script from "./web3.vue?vue&type=script&lang=js&"
export * from "./web3.vue?vue&type=script&lang=js&"
import style0 from "./web3.vue?vue&type=style&index=0&id=47d69866&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d69866",
  null
  
)

export default component.exports